import CustomCard from "../../../../components/CustomCard";
import { Avatar } from "@mui/material";
import IconPersonDefault from "../../../../assets/ImagesDefaults/ic-person-v2.svg";
import CustomChip from "../../../../components/CustomChip";
import { colors } from "../../../../enums/colors";
import {
    AccessDevicesTitle,
    IconClockTable
} from "../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../components/CustomTooltip";
import { getTimeFormat } from "../../../../Apis/functions";
import ServicesAccessMethod from "./ServicesAccessMethod";
import AccessInfoItem from "../../Guard/AccessMonitoring/SubComponent/AccessInfoItem";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    FullStack Developer
 * @Email       kpozos@ibl.mx
 */

const DailyServicesCompactRow = ({ row, t }) => {

    const accessInfoItems = [
        {
            icon: IconClockTable,
            label: t('time'),
            value: getTimeFormat(row.entryDate),
        },
        {
            icon: AccessDevicesTitle,
            label: t('device'),
            value: row.entryDeviceName,
        }
    ];

    return (
        <>
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 py-1 py-lg-0'>
                <div className="d-flex align-items-center gap-12px">

                    <CustomCard classCard='card-border-8px' classContent='p-0 background-primary-25'>
                        {row.image ? (
                            <img src={`data:image/jpeg;base64,${row.image}`} alt="avatar"
                                className="w-40px h-40px object-fit-cover rounded-circle"
                            />
                        ) : (
                            <Avatar src={IconPersonDefault} className='me-12px p-1'/>
                        )}
                    </CustomCard>

                    <div className='flex-grow-0 minw-0'>
                        <CustomTooltip
                            text={row.fullName}
                            classes='fs-16px ibl-font-w-600 text-capitalize text-ellipsis-1-row'
                            showIfTruncated
                            placement='top'
                        />
                    </div>

                    <div className='vertical-separator-shades-950 h-36px d-none d-md-block' />

                    <CustomChip
                        legend={`ID No ${row.employeeId}`}
                        background={colors.secondary100}
                        fontColor={colors.secondary700}
                        borderColor={colors.secondary150}
                    />

                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 py-1 py-lg-0'>
                <div className='d-flex flex-wrap justify-content-start justify-content-lg-end align-items-center'>
                    {accessInfoItems.map((item, index) => (
                        <AccessInfoItem
                            key={index}
                            icon={item.icon}
                            label={item.label}
                            value={item.value}
                        />
                    ))}
                </div>

            </div>
            <div className='col-sm-12 col-md-12 col-lg-2 py-1 py-lg-0'>

                <div className='d-flex justify-content-lg-end'>
                    <ServicesAccessMethod
                        row={row}
                        t={t}
                    />
                </div>

            </div>
        </>
    );
};

export default DailyServicesCompactRow;
